/* eslint-disable @typescript-eslint/naming-convention */
import { Component, OnInit } from '@angular/core';
import { AlertController, MenuController, NavController, PopoverController } from '@ionic/angular';
import { time } from 'console';
import { SettingMenuComponent } from 'src/app/components/setting-menu/setting-menu.component';
import { AccessService } from 'src/app/providers/access/access.service';
import { ApiService } from 'src/app/providers/apiService/api.service';
import { StorageService } from 'src/app/providers/storageService/storage.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.page.html',
  styleUrls: ['./home.page.scss'],
})

export class HomePage {
  user: any;
  unreadCount: any;
  savedCount: any;
  currentSavedSubmission: any;
  showBackdrop = false;
  first_name = "";
  lockTimer:any;

  constructor(
    public menuCtrl: MenuController,
    public apiService: ApiService,
    public alertController: AlertController,
    private navCtrl: NavController,
    private popoverCtrl: PopoverController,
    public storageService: StorageService, 
    public accessService: AccessService,

  ) { 
    this.storageService.getObject('mbeUser').then((userResult) => {
      //console.log('user info:', userResult);
      if (userResult == null)
      {
        this.storageService.getObject('tutorialWatched').then((result) => {
          if (result == null) {
            this.storageService.clear();
          }
          else
          {
            this.storageService.clear();
            this.storageService.set('tutorialWatched', 'true');
          }
        });
        this.navCtrl.navigateRoot('/login');
      }
      this.first_name = userResult.first_name;

    });
    
  }

  ionViewDidEnter() {
    //console.log('resetting logout timer');
    this.accessService.resetLogoutTimer();
    this.accessService.startTimer();
    this.getnotificationCount();
    this.checkSavedSubmissions();
    this.getRejectnotificationCount();
  }

  getnotificationCount() {
    this.apiService
      .post('user/get-unread-notification-count', {})
      .subscribe(
        (res) => {
          if (res.error === false) {
            this.unreadCount = res.data.unread_notifications;
          }
        },
        (err) => {
          //console.log(err);
        }
      );
  }

  

  checkSavedSubmissions() {
    var params = {
      isportal:'false'
    };  
    this.savedCount = 0;
    this.apiService
      .post('data/check-saved-submissions', params)
      .subscribe(
        (res) => {
          if (res.error === false) {
            this.savedCount = res.data.saved_count;
            this.currentSavedSubmission = res.data.submissionid;
          }
        },
        (err) => {
          //console.log(err);
        }
      );
  }

  getRejectnotificationCount() {
    this.apiService
      .post('user/get-unread-rejected-notification-count', {})
      .subscribe(
        async (res) => {
          if (res.error === false) {
            //console.log('rejected count: ',res.data.unread_notifications);
            if (res.data.unread_notifications>0)
            {
              const alert = await this.alertController.create({
                cssClass: 'fail_alert', 
                header: 'Unread Submissions Returned for Action!',
                mode:'ios',
                animated: true,
                message: 'You have ' + res.data.unread_notifications + ' unread notifications regarding submissions returned for action.<br><br>Please tap OK to review your unread notifications.',
                buttons: [
                  {
                    text: 'Later',
                    role: 'cancel',
                    cssClass: 'red',
                    handler: (blah) => {
                    }
                  }, {
                    text: 'OK',
                    cssClass: 'action',
                    handler: () => {
                      this.navCtrl.navigateForward('notification');
                    }
                  } 
              
              ] });
              await alert.present();
            }
          }
        },
        (err) => {
          //console.log(err);
        }
      );
  }


  unlock() {
    //console.log('unlocking?');
    this.showBackdrop = false;
    this.navCtrl.navigateRoot('lock');

  }
  async submissionHelp(ev) {
    const alert = await this.alertController.create({
      cssClass: 'success_alert noheight blue', 
      mode:'ios',
      animated: true,
      message: '<div class="basicbox">Basic</div> <br><br>The Medbill App allows you to submit billing by simply taking photos of billing sheets.  Submissions of this type are called Basic Submissions.  This is the most efficient way for you to submit your billing sheets. <br><br><div class="advancedbox">Advanced</div><br><br>Advanced submissions are best for repeat patients, ward rounds and individual surgical, ICU or anaesthetic patients.',
      buttons: [
        {
          text: 'OK',
          cssClass: 'action'
        } 
    
    ] });
    await alert.present();
  }
  async presentOptionMenu(ev) {
    const popover = await this.popoverCtrl.create({
      component: SettingMenuComponent,
      componentProps: {hasAppLock: this.showBackdrop},
      reference:'event',
      alignment:'end',
      side:'bottom',
      event: ev,
      mode: 'md',
      arrow:true,
      backdropDismiss: true,
      keyboardClose: true,
      showBackdrop: true,
    });
    await popover.present();
    const { data } = await popover.onDidDismiss();
    if (data === 'lock') {
      if (this.showBackdrop) {
        //console.log('here1');
        this.navCtrl.navigateRoot('lock');
      } else {
        this.showBackdrop = true;
        setTimeout(() => {
          this.showBackdrop = false;
          //console.log('here2');
          this.navCtrl.navigateRoot('lock');
        }, 300000);
      }
    }
    if (data === 'logout') {
      this.apiService.logout();
    }

  }
}



